import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ApiError } from '@/lib/apiClient';
import { AuthProvider } from '@/hooks/useAuth';
import { App } from '@/App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      // Inutile de réessayer une erreur d'authentification ou de validation.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && (error.isAuthError || error.status === 400)) return false;
        return failureCount < 2;
      },
    },
    // `always` exécute immédiatement notre garde hors-ligne : React Query ne
    // met donc jamais une mutation en pause pour la rejouer à la reconnexion.
    mutations: { retry: 0, networkMode: 'always' },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error("Élément #root introuvable dans index.html.");

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
